/* unplugin-vue-components disabled */import { render } from "./StandardButton.vue?vue&type=template&id=349700e6&scoped=true&ts=true"
import script from "./StandardButton.vue?vue&type=script&lang=ts"
export * from "./StandardButton.vue?vue&type=script&lang=ts"

import "./StandardButton.vue?vue&type=style&index=0&id=349700e6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-349700e6"]])

export default __exports__